import React from "react";
import NeedMoreSupport from "./modules/NeedMoreSupport";
import HomePageBanner from "./modules/HomePageBanner";
import HomePageTab from "./modules/HomePageTab";
import SignIn from "../components/modules/Signin";
import NBA from "./modules/NBA";
import AlertBanner from "./modules/AlertBanner";
import { SIT_SERVER, MAIN_SERVER } from "../constants/constants";
import { Chat } from "./modules/IncludeChat";
import { RTCICall } from "./modules/RTCICall";
import { getOS, isNullOrUndefined, updateUserID, RemoveHeaderHiddenClass } from "./modules/CommonFunctions";
import { SiteCatalyst } from '../components/modules/SiteCatalyst';
import ErrorBoundary from './modules/ErrorHandler';
import { CovidAlert } from './modules/CovidAlert';
import { Header } from './modules/HeaderContent';
import { Footer } from './modules/FooterContent';
import { MS_LOCATION } from "../constants/constants";

export default class Home extends React.Component {
  constructor(props) {
    super(props);
    this.isValidUser = document.cookie.indexOf('userinfo') > -1 ? true : false; 
    this.availableDevices = [
      "overview",
      "billing & account",
      "internet",
      "tv",
      "phone"
    ];
    if (
      !isNullOrUndefined(this.props.AvailableDevices) &&      
      this.props.AvailableDevices !== "ALL" &&
      this.props.AvailableDevices.length > 0
    ) {
      this.availableDevices = [];
      this.availableDevices = this.props.AvailableDevices.map(function(x) {
        return x.toLowerCase();
      });
      if(this.availableDevices.indexOf("overview") < 0) {
        this.availableDevices.push("overview");
      }
      if(this.availableDevices.indexOf("billing & account") < 0) {
        this.availableDevices.push("billing & account");
      }
    }
  }

  componentDidMount() {
    let operatingSystem = getOS();
    let intent = "";
    let nbaCount = 0;
    let strOutage = "";
    let strOutagetype = "";
    // logfortouchpointcall ** 
    if( this.isValidUser && (!window.tpRequest || (window.tpRequest && (window.tpRequest.idMap.tid === "" || JSON.parse(window.tpRequest.tpReq).header.appServername !== "NBA-ESUPPORT" )))){
      let testData = { ...window.homePageDynamicData , type : 'checkForError' , id: "ErrorCheck" }
      fetch(MS_LOCATION + "/logfortouchpointcall", {
        method: "POST",
        headers: new Headers({
          "content-type": "application/json"
        }),
        body: JSON.stringify(testData)
      });
    }

    setTimeout(() => {
    if(this.isValidUser){
    let logData = { ...window.homePageDynamicData , type : 'componentDidMount' , ...window.tpRequest }
    fetch(MS_LOCATION + "/logfortouchpointcall", {
      method: "POST",
      headers: new Headers({
        "content-type": "application/json"
      }),
      body: JSON.stringify(logData)
    }); 
    }    
    }, 1000); // **
    let args = {
      homepage_name : "Residential Help",
      intentCategory: "NBA_DISPLAY",
      activityCategory: "NBA_DISPLAY",
      intent: intent,
      app_n_channel: "NBA-ESUPPORT",
      os: operatingSystem,
      pegaSessionID: "",
      userid: (this.isValidUser) ? window.userinfo.userId : "",
      visionID :  (this.isValidUser) ? window.userinfo.visionId : "",
      accountID:  (this.isValidUser) ? window.userinfo.visionAcctId : ""
      };
      RTCICall(args);
    // }
    if (window.homePageDynamicData != null && window.homePageDynamicData.resourcesummary != null) {	
      for(let i = 0; i < window.homePageDynamicData.resourcesummary.length; i++) {
        intent = window.homePageDynamicData.resourcesummary[i].resourceid;
        let appChannelValue = "";
        let intentlowercase = "";
        let strPPSHOutage ="PPSH_GENERIC_OUTAGE";
        intentlowercase = intent.toLowerCase();
        var intentArray = ["ppsh_generic_biml_lowermybill", "ppsh_generic_piml_manageautopay", "ppsh_generic_biml_pmt_arrng",
                            "ppsh_generic_autopay_cnf","ppsh_generic_outage_ipr"];
        if(intentArray.indexOf(intentlowercase)!== -1)  {
            //value exists
            appChannelValue = "ESUPPORT";
        }  
        else{
            appChannelValue = "NBA-ESUPPORT";
        }               
        // if(intent == "PPSH_Generic_BIML_Lowermybill" || intent == "PPSH_Generic_PIML_Manageautopay" || 
        //     intent == "PPSH_Generic_Biml_PMT_Arrng" || intent == "PPSH_Generic_Autopay_CNF" ||
        //     intent == "PPSH_GENERIC_OUTAGE_IPR"){
        //     appChannelValue = "ESUPPORT";
        // }
        // else{
        //     appChannelValue = "NBA-ESUPPORT";
        // }
        if(intent != null){
          if(intentlowercase == strPPSHOutage.toLocaleLowerCase()){
              strOutage ="OutageType";
              strOutagetype = window.homePageDynamicData.resourcesummary[i].insights.outagetype;
             }
         }
        if(intent != null && !isNullOrUndefined(window.homePageDynamicData.resourcesummary[i].insights.verbiage) && window.homePageDynamicData.resourcesummary[i].insights.verbiage !== "") {
          nbaCount = nbaCount + 1;
          let args = {
            intentCategory: "NBA_DISPLAY",
            activityCategory: "NBA_DISPLAY",
            intent: intent,
            app_n_channel: "NBA-ESUPPORT",
            os: operatingSystem,
            outage:strOutage,
            outagetype:strOutagetype,
            pegaSessionID: (!isNullOrUndefined(window.homePageDynamicData.Attribute) && !isNullOrUndefined(window.homePageDynamicData.Attribute.content)) ? window.homePageDynamicData.Attribute.content : "",
            userid: (this.isValidUser) ? window.userinfo.userId : "",
            visionID :  (this.isValidUser) ? window.userinfo.visionId : "",
            accountID:  (this.isValidUser) ? window.userinfo.visionAcctId : ""
            };
            RTCICall(args);
            if(nbaCount === 2) { break; } // NBA RTCI call will send for two items only in page load
        }
      }
    }
    updateUserID();
   // window.constructScData('urlPageLoad','');
    Chat();
    RemoveHeaderHiddenClass();
  }

  getSignInUrl() {
    // let currentLocation = window.location.href;
    // let url = currentLocation.indexOf("sit") > -1 ? SIT_SERVER : MAIN_SERVER;
    // window.location.href =
    //   url +
    //   "home/myverizon/?goto=" +
    //   window.encodeURIComponent(currentLocation);
    let currentLocation = window.location.href;
    let url = currentLocation.indexOf("sit") > -1 ? SIT_SERVER : MAIN_SERVER;
  
      if(currentLocation.indexOf("sit") > -1 || currentLocation.indexOf("qa1j0fv") > -1){
        window.location.href ="https://securesit1.verizon.com/signin?goto=" + 
        window.encodeURIComponent(currentLocation);
      }
      else if(currentLocation.indexOf("www98") > -1){
        window.location.href ="https://secure.verizon.com/signin?goto=" + 
        window.encodeURIComponent(currentLocation);
      }else{
        window.location.href ="https://secure.verizon.com/signin?goto=" + 
        window.encodeURIComponent(currentLocation);
      }
  }

  render() {
    document.body.classList.add("home_page");
    let isSignInUser = document.cookie.indexOf("userinfo") > -1 ? true : false;
    if (isSignInUser) {
      return (
        <React.Fragment>
          <ErrorBoundary>
            <Header/>
          </ErrorBoundary>
          <ErrorBoundary>
          <NBA
            pageName="home"
            NBAData={
              !isNullOrUndefined(this.props.DynamicData) &&
              this.props.DynamicData.resourcesummary !== undefined
                ? this.props.DynamicData.resourcesummary
                : []
            }
          />
          </ErrorBoundary>

          <main role="main">
            <ErrorBoundary>
            <HomePageBanner
              Title={this.props.Banner.bannerTitle}
              Image={this.props.Banner.bannerImage}
            />
             <ErrorBoundary>
            <SignIn
              CallBack={() => this.getSignInUrl()}
              isSignIn={isSignInUser}
            />
            </ErrorBoundary>
            </ErrorBoundary>
            <ErrorBoundary>
              <div className="row alert-Position">
                <AlertBanner
                  AlertBannerData={this.props.AlertBanner}
                  isBreadCrumb={false}
                />
              </div>
            </ErrorBoundary>
            {
              !isNullOrUndefined(window.homePageData.rtelist) && window.homePageData.rtelist.length > 0 &&  <ErrorBoundary>
                <CovidAlert content={window.homePageData.rtelist[0].richText}/>
              </ErrorBoundary>
            }
            <ErrorBoundary>
              <HomePageTab
                AvailableDevices={this.availableDevices}
                Header={this.props.Title[0].titleDescription[0].title}
                Content1={this.props.Title[1].ctaList[0].label1}
                Link1SCID={this.props.Title[1].ctaList[0].sclinktrackid}
                Link1={this.props.Title[1].ctaList[0].linkTo}
                Content2={this.props.Title[2].ctaList[0].label1}
                Link2SCID={this.props.Title[2].ctaList[0].sclinktrackid}
                Link2={this.props.Title[2].ctaList[0].linkTo}
                TabData={this.props.TabData}
              />
            </ErrorBoundary>
            <ErrorBoundary>
            <NeedMoreSupport Data={this.props.NeedMoreSupportData} />
            </ErrorBoundary>
          </main>
          <ErrorBoundary>
            <Footer/>
          </ErrorBoundary>
          <input type="hidden" value="Auth" id="loginType"/>
          <ErrorBoundary>
          <SiteCatalyst PageDetails={this.props.NeedMoreSupportData.pagedetails}/>
          </ErrorBoundary>
        </React.Fragment>
      );
    } else {
      return (
        <React.Fragment>
           <ErrorBoundary>
            <Header/>
          </ErrorBoundary>
          <main role="main">
            <ErrorBoundary>
            <HomePageBanner
              Title={this.props.Banner.bannerTitle}
              Image={this.props.Banner.bannerImage}
            />
            </ErrorBoundary>
            <ErrorBoundary>
            <SignIn
              CallBack={() => this.getSignInUrl()}
              isSignIn={!isSignInUser}
            />
            </ErrorBoundary>
            <ErrorBoundary>
              <div className="row alert-Position">
                <AlertBanner
                  AlertBannerData={this.props.AlertBanner}
                  isBreadCrumb={false}
                />
              </div>
            </ErrorBoundary>
            {
              !isNullOrUndefined(window.homePageData.rtelist) && window.homePageData.rtelist.length > 0 &&  <ErrorBoundary>
                <CovidAlert content={window.homePageData.rtelist[0].richText}/>
              </ErrorBoundary>
            }
            <ErrorBoundary>
            <HomePageTab
              AvailableDevices={this.availableDevices}
              Header={this.props.Title[0].titleDescription[0].title}
              Content1={this.props.Title[1].ctaList[0].label1}
              Link1={this.props.Title[1].ctaList[0].linkTo}
              Content2={this.props.Title[2].ctaList[0].label1}
              Link2={this.props.Title[2].ctaList[0].linkTo}
              TabData={this.props.TabData}
            />
            </ErrorBoundary>
            <ErrorBoundary>
            <NeedMoreSupport Data={this.props.NeedMoreSupportData} />
            </ErrorBoundary>
          </main>
          <ErrorBoundary>
            <Footer/>
          </ErrorBoundary>
          <input type="hidden" value="UnAuth" id="loginType"/>
          <ErrorBoundary>
          <SiteCatalyst PageDetails={this.props.NeedMoreSupportData.pagedetails}/>
          </ErrorBoundary> 
        </React.Fragment>
      );
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/HomePage.js